import { history } from "helpers/sharedHelpers";
import urls from "utils/constants/urls";
import { Types as AlertTypes } from "../../store/ducks/modalAlert";

export const showAcademyAppOnlyModal = (dispatch) => {
  dispatch({
    type: AlertTypes.SET_ALERTS_REQUEST,
    messages: {
      title: "Sua experiência de cursos acontece pelo app.",
      msg: "Baixe o aplicativo ou procure por “Pintou Parceria” na loja do seu celular para continuar.",
      preventClose: true,
      buttons: [
        {
          title: "Voltar para home",
          variant: ["transparent"],
          event: () => history.push(urls.ROUTES.MURAL),
        },
        {
          title: "Ir para o aplicativo",
          preventCloseAfterClick: true,
          event: () => {
            window.open(
              "https://apps.apple.com/br/app/noz-plataforma-de-comunica%C3%A7%C3%A3o/id1373272426",
              "_blank",
            );
          },
        },
      ],
    },
  });
};
